module.exports = __webpack_public_path__ + "static/img/right-home-row-3.d177e0d7.webp";